import clsx from "clsx";
import React, { ReactNode, forwardRef, CSSProperties } from "react";
import { EIconSize } from "../interface/Icon";
import { SvgIconRoot } from "./SvgIcon.styles";

export interface ISvgIconProps {
  children?: ReactNode;
  component?: any;
  className?: string;
  style?: CSSProperties;
  titleAccess?: string;
  viewBox?: string;
  fill?: string;
  xmlns?: string;
  color?: string;
  size?: EIconSize;
}

const SvgIcon = forwardRef<any, ISvgIconProps>(function SvgIcon(props, ref) {
  const {
    children,
    component,
    className,
    titleAccess,
    viewBox = "0 0 24 24",
    xmlns = "http://www.w3.org/2000/svg",
    color,
    size = 24,
    style,
  } = props;

  return (
    <SvgIconRoot
      as={component}
      className={clsx(className)}
      ref={ref}
      titleAccess={titleAccess}
      viewBox={viewBox}
      xmlns={xmlns}
      color={color}
      $size={size}
      width={size}
      height={size}
      style={style}
    >
      {children}
    </SvgIconRoot>
  );
});

export default SvgIcon;
